module.exports = __webpack_public_path__ + "static/media/4.41d89f70.jpg";